import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { COUNTRY_NAME_BY_CODE, COUNTRY_OPTIONS } from '../constants/geo';

// One country by ISO code, labelled "NL — Netherlands" like the shipping-zone picker.
// `value` and `onChange` use the upper-case code; extra props go to the TextField.
const CODES = COUNTRY_OPTIONS.map((c) => c.code);
const label = (code) => (COUNTRY_NAME_BY_CODE[code] ? `${code} — ${COUNTRY_NAME_BY_CODE[code]}` : code);

export default function CountrySelect({ value, onChange, label: fieldLabel = 'Country', size = 'small', sx, ...fieldProps }) {
  const code = (value || '').toUpperCase();
  return (
    <Autocomplete
      size={size}
      options={CODES}
      value={code || null}
      onChange={(_e, next) => onChange(next || '')}
      getOptionLabel={label}
      autoHighlight
      fullWidth={fieldProps.fullWidth}
      sx={sx}
      renderInput={(params) => <TextField {...params} label={fieldLabel} {...fieldProps} />}
    />
  );
}
